import { render, staticRenderFns } from "./Webmegler.vue?vue&type=template&id=137349da"
import script from "./Webmegler.vue?vue&type=script&lang=js"
export * from "./Webmegler.vue?vue&type=script&lang=js"
import style0 from "./Webmegler.vue?vue&type=style&index=0&id=137349da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports